import { render, staticRenderFns } from "./RidersTitle.vue?vue&type=template&id=bb7dcc1e&lang=pug&"
import script from "./RidersTitle.vue?vue&type=script&lang=js&"
export * from "./RidersTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports